import React, { PropsWithChildren, useState } from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import TooltipWrapper from '../tooltip/tooltip';
import _noop from 'lodash/noop';

interface Props {
	className?: string;
	text: string;
	translations: {
		defaultTooltip: string;
		successTooltip: string;
	};
	onCopyClicked?: () => void;
	padding?: number;
	fontSize?: number;
}

const CopyToClipboardTooltip: React.FC<Props> = ({
	className,
	text,
	translations,
	onCopyClicked = _noop,
	padding = 12,
	fontSize = 18,
	children
}: PropsWithChildren<Props>) => {
	const [toolTipText, setToolTipText] = useState(translations.defaultTooltip);
	const [isCopied, setIsCopied] = useState(false);

	const copyToClipboard = async () => {
		await navigator.clipboard.writeText(text);
		setToolTipText(translations.successTooltip);
		setIsCopied(true);
		setTimeout(() => {
			setToolTipText(translations.defaultTooltip);
			setIsCopied(false);
		}, 1000);
		onCopyClicked();
	};
	return (
		<span className={`copy-to-clipboard-tooltip ${className || ''}`} style={{ padding, fontSize }}>
			<TooltipWrapper overlayClassName="copy-to-clipboard-default-tooltip" title={toolTipText}>
				<span className="copy-button" onClick={copyToClipboard}>
					{isCopied
						? children || <BringgIcon iconName={BringgFontIcons.Selected} />
						: children || <BringgIcon iconName={BringgFontIcons.Copy} />}
				</span>
			</TooltipWrapper>
		</span>
	);
};
export default CopyToClipboardTooltip;
